import { gql } from '@apollo/client';

const QUERY_ALL_PEDAGOGICAL_CHALLENGES = gql`
  query HomeDefis {
    getHomeDefis {
      defisList {
        id
        name
        debut
        fin
      }
      lastDefi {
        id
        name
        recompenses {
          category
          lots
          recompenses_winners {
            id
            username
            avatar {
              media {
                url
              }
            }
            classes {
              lycee {
                name
              }
            }
          }
        }
      }
    }
  }
`;
export default QUERY_ALL_PEDAGOGICAL_CHALLENGES;
